export default {
  title: 'Adresse de livraison',
  buttons: {
    save: 'Enregistrer',
  },
};
